const HeaderMessagesComponent = ({
  userImage,
  messageBy,
  createdAt,
  status,
  messageType,
}) => {
  return (
    <div className="tw-flex tw-items-center">
      <img
        className="tw-rounded-full tw-mr-4 tw-max-w-none tw-w-24 tw-h-24"
        src={userImage ?? "/imgs/1.png"}
        alt="client profile"
      />
      <div className="tw-flex lg:!tw-gap-10 gap-2 tw-w-full max-lg:tw-flex-col tw-text-[16px]">
        <div className="tw-flex tw-flex-col">
          <div className="tw-mb-2">
            <span className="tw-font-semibold tw-text-primary">By : </span>
            <span className="tw-text-slate-600">{messageBy}</span>
          </div>
          <div>
            <span className="tw-font-semibold tw-text-primary">At : </span>
            <span className="tw-text-slate-600">{createdAt}</span>
          </div>
        </div>
        <div className="tw-flex tw-flex-col">
          <div className="tw-mb-2">
            <span className="tw-font-semibold tw-text-primary">Status : </span>
            <span className="tw-text-slate-600">{status}</span>
          </div>
          <div>
            <span className="tw-font-semibold tw-text-primary">Type : </span>
            <span className="tw-text-slate-600">{messageType}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderMessagesComponent;
